<template>
    <div class="g-content admire">
        <div class="content-manage">
            <div class="list">
                <div class="list-item">
                    <img :src="taskInfo.gameLogo" alt="" class="list-img" style="width: 67px;height:67px;" />
                    <div class="list-content">
                        <div class="title" @click="preview(taskInfo.pageUrl)">
                            <a href="javascript:;">{{ taskInfo.title }}</a>
                        </div>
                        <div class="detail-data">
                            <div class="data-item">
                                <div class="data-title">累计注册用户</div>
                                <div class="data-num">{{ totalRegister }}</div>
                            </div>
                            <div class="data-item">
                                <div class="data-title">累计收益</div>
                                <div class="data-num">{{ totalProfit }}</div>
                            </div>
                        </div>
                        <div class="info">
                            <div>
                                <span class="task-price">{{
                  Number(taskInfo.cpa).toFixed(2)
                }}</span>元
                                <span class="task-tag">CPA</span>

                                <i class="ico ico-time"></i>
                                <span>{{ taskInfo.startTime }} ~ {{ taskInfo.endTime }}</span>
                            </div>
                        </div>
                        <div class="btm">
                            <div class="time">{{ taskInfo.channelDesc }}</div>
                            <div class="action">
                                <div class="copy" @click="handle(taskInfo.pageUrl, taskInfo, 'copy')">
                                    <img src="~Assets/img/pages/v4/icon_copy.png" alt="" />
                                    复制链接
                                </div>
                                <!-- <el-popover
                                placement="top-start"
                                width="200"
                                trigger="hover"
                                content="移动端即将上线，敬请期待！"> -->
                                <div class="copy" slot="reference" @click="handle(taskInfo.pageUrl, taskInfo, 'showQrCode')">
                                    <img src="~Assets/img/pages/v4/icon_sao.png" alt="" />
                                    移动端二维码
                                </div>
                                <!-- </el-popover> -->

                                <div class="preview" @click="handle(taskInfo.pageUrl, taskInfo, 'preview')">
                                    PC预览
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="last-time" v-show="latestTime">
                数据已刷新至 {{ latestTime }}
            </div>
            <div class="data-part">
                <el-table v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.1)" :data="tableData" stripe class="data-table" style="width: 100%">
                    <el-table-column prop="date" label="日期" width="140" align="center">
                    </el-table-column>
                    <el-table-column prop="visitNum" label="页面曝光" align="right">
                        <template slot-scope="scope">
                            {{ scope.row.visitNum | filterNum }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="androidVisitNum" label="页面曝光-安卓" align="right">
                        <template slot-scope="scope">
                            {{ scope.row.androidVisitNum | filterNum }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="iosVisitNum" label="页面曝光 - ios" align="right">
                        <template slot-scope="scope">
                            {{ scope.row.iosVisitNum | filterNum }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="downloadNum" label="点击下载" align="right">
                        <template slot-scope="scope">
                            {{ scope.row.downloadNum | filterNum }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="androidDownloadNum" label="点击下载-安卓" align="right">
                        <template slot-scope="scope">
                            {{ scope.row.androidDownloadNum | filterNum }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="iosDownloadNum" label="点击下载 - ios" align="right">
                        <template slot-scope="scope">
                            {{ scope.row.iosDownloadNum | filterNum }}
                        </template>
                    </el-table-column>
                    <!-- <el-table-column prop="registerNum" label="注册成功" align="right">
                    </el-table-column>
                    <el-table-column prop="profit" label="收益（元）" align="right">
                    </el-table-column> -->
                </el-table>
                <el-pagination style="margin-top:15px" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page" :page-sizes="[5, 10, 20, 50, 100, 200]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
                </el-pagination>
            </div>
            <div class="copy-tip" v-show="copyTipVisible" :style="{ opacity: copyStyle ? 1 : 0 }">
                <img src="~Assets/img/pages/v4/copy_success.png" alt="" />
                <span>复制成功</span>
                ，现在可以直接粘贴链接地址了。
            </div>
            <div class="qrcode" v-show="qrCodeVisible">
                <div class="title">移动端二维码</div>
                <span class="close" @click="qrCodeVisible = false"></span>
                <div class="info">请使用微信扫描二维码，查看移动端效果</div>
                <div class="code">
                    <img :src="codeSrc" alt="" />
                </div>
            </div>
            <div class="mask" v-show="qrCodeVisible"></div>
        </div>
    </div>
</template>

<script>
import QRCode from "qrcode";
import {
    DownloadTaskInfo,
    DownloadTaskData,
    DownloadTaskPage,
    DownloadTaskDataHour
} from "Services/getData.js";
export default {
    data() {
        return {
            qrCodeVisible: false,
            copyTipVisible: false,
            copyStyle: false,
            isCopy: false,
            codeSrc: "",
            tableData: [{}],
            userTaskId: "",
            taskId: "",
            totalRegister: "",
            totalProfit: "",
            taskInfo: {},
            page: 1,
            pageSize: 10,
            latestTime: "", //最新的数据
            loading: false,
            total: 0
        };
    },
    mounted() {
        this.userTaskId = this.$route.query.userTaskId;
        this.taskId = this.$route.query.taskId;
        this.getDownloadTaskInfo();
        this.getDownloadTaskDataHour();
    },
    methods: {
        async handle(href, item, type) {
            if (!href) {
                let res = await DownloadTaskPage({
                    id: this.userTaskId
                });
                if (res.status === 200 && res.data.code === 0) {
                    if (!res.data.data.url) {
                        this.$alert("链接正在生成中，请2分钟后重试");
                    } else {
                        this.taskInfo.pageUrl = res.data.data.url;
                        this.control(res.data.data.url, item, type);
                    }
                }
            } else {
                this.control(href, item, type);
            }
        },
        control(href, item, type) {
            switch (type) {
                case "copy":
                    this.copy(href);
                    break;
                case "showQrCode":
                    this.showQrCode(href);
                    break;
                case "preview":
                    this.preview(href);
                    break;
            }
        },
        async getDownloadTaskDataHour() {
            this.loading = true;
            let res = await DownloadTaskDataHour({
                id: this.userTaskId,
                page: this.page,
                pageSize: this.pageSize
            });
            if (res.status === 200 && res.data.code === 0) {
                if (this.page === 1 && res.data.data.list.length) {
                    this.latestTime = res.data.data.list[0].date; //获取最新的一条数据
                }
                this.total = res.data.data.count;
                this.tableData = res.data.data.list;
                this.totalRegister = res.data.data.totalRegister;
                this.totalProfit = res.data.data.totalProfit;
            }
            this.loading = false;
        },
        handleCurrentChange(page) {
            this.page = page;
            this.getDownloadTaskDataHour();
        },
        handleSizeChange(pageSize) {
            this.pageSize = pageSize;
            this.page = 1;
            this.getDownloadTaskDataHour();
        },
        preview(href) {
            window.open(href);
        },
        async getDownloadTaskInfo(a, b, c) {
            let res = await DownloadTaskInfo({
                taskId: this.taskId
            });
            if (res.status === 200 && res.data.code === 0) {
                this.taskInfo = res.data.data;
            }
        },
        showQrCode(href) {
            this.qrCodeVisible = true;
            QRCode.toDataURL(href)
                .then(url => {
                    // console.log(url)
                    this.codeSrc = url;
                })
                .catch(err => {
                    // console.error(err)
                    this.codeSrc = "";
                });
        },
        copy(href) {
            const input = document.createElement("input");
            document.body.appendChild(input);
            input.setAttribute("value", href);
            input.select();
            if (document.execCommand("copy")) {
                document.execCommand("copy");
            }
            document.body.removeChild(input);
            this.showCopyTip();
        },
        showCopyTip() {
            if (!this.isCopy) {
                this.isCopy = true;
                this.copyTipVisible = true;
                setTimeout(() => {
                    this.copyStyle = true;
                }, 20);
                setTimeout(() => {
                    this.copyStyle = false;
                    setTimeout(() => {
                        this.copyTipVisible = true;
                        this.isCopy = false;
                    }, 20);
                }, 2000);
            }
        }
    }
};
</script>
<style lang="scss" scoped>
@import '~Assets/sass/pages/v4/admire/index.scss';
.g-content.admire {
    padding: 0;
    background: transparent;
    .content-manage {
        .list-item {
            border: 0;
            background: #fff;
            box-shadow: none;
        }
        .date {
            position: relative;
            width: 300px;
            border: none;
            border-bottom: 1px solid rgba(235, 235, 235, 1);
            border-radius: 0;
        }
        .task-price {
            font-size: 20px;
        }
        .task-tag {
            display: inline-block;
            line-height: 20px;
            padding: 0 5px;
            text-align: center;
            font-size: 14px;
            background: #fff2e8;
            color: #fd7e28;
        }
        .ico-time {
            vertical-align: -3px;
            margin-right: 5px;
            margin-left: 60px;
        }
        .list-content {
            position: relative;
        }
        .detail-data {
            position: absolute;
            right: 0;
            top: 0;
            text-align: center;
            color: #666;
            .data-item {
                display: inline-block;
                margin-left: 50px;
            }
            .data-title {
                font-size: 14px;
            }
            .data-num {
                font-size: 22px;
            }
        }
        .data-part {
            padding: 30px;
            background: #fff;
            .data-table {
                border: 1px solid #ebeef5;
                margin-bottom: 30px;
            }
        }
    }
    .last-time {
        margin: 15px;
    }
}
</style>
